import React, { useState } from 'react';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Icone from 'Component/Icone';
import Aula from 'Interface/Aulas';
import { useEditarModuloMutation } from 'Service';

import Editar from './Editar';

interface Props {
    dados: Aula;
    acoes?: boolean;
}

const Lista = ({ dados }: Props): React.ReactElement =>
{
    const toast = useToast();
    const [ modal, setModal ] = useState<boolean>(false);
    const [ editar ] = useEditarModuloMutation();

    const remover = async (): Promise<void> =>
    {
        try {
            await editar({ id: dados.id, ativo: false }).unwrap();

            toast({
                conteudo: 'Removido com sucesso!',
                tema: 'success',
            });
        } catch (erro) {
            toast({
                titulo: 'Erro ao remover',
                conteudo: 'Verifique o registro de log para mais detalhes!',
                tema: 'danger',
            });
        }
    }

    return (
        <React.Fragment>
            <div className="border-top py-2 px-3 fs-5 d-flex align-items-center">
                <div className="fs-2 d-inline-block me-3">
                    <Icone nome="play-fill" />
                </div>
                <span className="cursor-pointer" onClick={ () => setModal(true) }>
                    { dados.titulo }
                </span>
                <div className="ms-auto">
                    <Botao
                        icone="trash"
                        tema="danger"
                        className="ms-5 align-self-end"
                        confirmacao="Você tem certeza que deseja remover essa aula? Essa ação é irreversivel."
                        onClick={ remover }
                    />
                </div>
            </div>
            <Editar
                aulaId={ dados.id }
                exibir={ modal }
                aoFechar={ setModal }
            />
        </React.Fragment>
    )
}

export default Lista;
